const DEFAULT_LOCAL_BACKEND_URL = 'http://localhost:3002';
const DEFAULT_PROD_BACKEND_URL = 'https://guarachat-backend.fly.dev';


function resolveBackendBaseUrl() {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  if (configuredUrl) {
    return configuredUrl;
  }

  if (process.env.NODE_ENV !== 'production') {
    return DEFAULT_LOCAL_BACKEND_URL;
  }

  return DEFAULT_PROD_BACKEND_URL;
}

export const backendBaseUrl = resolveBackendBaseUrl();

